import { TranslocoService } from "@ngneat/transloco";
import { UtilCommon } from "app/shared/common/utils/UtilCommon";
import { UtilComponent } from "app/shared/common/utils/UtilComponent";
import { extractUsername } from "app/shared/components/base/ag-grid-group";
import { REQUEST_CANDIDATE_STATUS, REQUEST_CANDIDATE_TASK_KEY, REQUEST_STATUS, REQUISITION_CANDIDATE_TASK_STATUS } from "./workflow-task.constant";
import { ICellRendererParams } from "ag-grid-community";
import { XAdvancedFilterControl, XAdvancedGroupControl } from "app/shared/components/x-advanced-filter/x-advanced-filter.model";
import { ControlType } from "app/shared/components/x-advanced-filter/x-advanced-filter.enum";
import { PostStatus } from "./service/post.const";
import { AttachmentCode } from "../recruit/candidate/constants";

export function getRowStyle(params) {
  if (params.data?.urgency === "LEVEL_1") {
    return { color: "#ff6f6f" };
  } else if (params.data?.urgency === "LEVEL_3") {
    return { color: "rgb(124 124 124)" };
  } else if (params.data?.urgency === "LEVEL_2") {
  } else {
    return null;
  }
}

function getNumberOfUrgen(value: string) {
  if (value === "LEVEL_1") {
    return 1;
  } else if (value === "LEVEL_2") {
    return 2;
  } else if (value === "LEVEL_3") {
    return 3;
  }
}

export function ellipsisRenderer(params: ICellRendererParams) {
  const value = UtilCommon.getValueByLanguage(params?.value?.value ? JSON.parse(params?.value?.value) : params.value || '');
  const maxLength = 50; // Set the maximum length before truncation

  // Display ellipsis if content is too long
  const truncatedValue =
    value.length > maxLength ? value.substring(0, maxLength) + '...' : value;

  // Create a span element to include a tooltip
  const span = document.createElement('span');
  span.textContent = truncatedValue;
  span.title = value; // Show full value on hover

  return span;
}

export const getCommonColumn = (
  utilComponent: UtilComponent,
  translocoService: TranslocoService,
  permissionRR: boolean = false
) => {
  // Not RR/RRM
  if (!permissionRR) {
    return [
      // utilComponent.commonColumnNo("No", "no", 100),
      {
        ...utilComponent.commonColumnAgGrid(
          "WORKFLOW.TASK.LABEL.REQUEST_TYPE",
          "requestType",
          200,
          false,
          false
        ),
        width: 200,
        toolPanelClass: 'visible', // Include in tool panel
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "WORKFLOW.TASK.LABEL.BUSINESS_KEY",
          "code",
          200,
          false,
          false,
        ),
        // hide: true,
        cellRenderer: (data) => {
          if (!data || !data?.value) {
            return "";
          }
          let hint = '';
          const postFlg = data?.data?.postFlg;
          const postStatus = data?.data?.postStatus;
          if (postFlg && !(PostStatus.DRAFT === postStatus || PostStatus.PENDING === postStatus)) {
            hint = '<span style="color: #FF9800; margin-left: 4px; font-size: 18px;">*</span>'
          }
          let pending = '';
          const pendingFlg = data?.data?.pendingFlg;
          if (pendingFlg) {
            pending = ' <span style="margin-left: 8px; font-style: italic ;font-weight: 700 ;padding: 4px 8px;background: #f52b2b; border-radius: 30px;color: white; font-size: 8px ">Pending</span>';
          }
          return `<span>${data?.value}</span> ${hint}${pending}`;
        },
      },
      {
        headerName: translocoService.translate("WORKFLOW.TASK.LABEL.JOB_TITLE"),
        cellStyle: getDefaultStyle(),
        field: "jobTitle",
        flex: 1,
        width: 300,
        minWidth: 250,
        cellRenderer: (data) => {
          let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
          return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
        },
        // suppressSizeToFit: true,
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "WORKFLOW.TASK.LABEL.LEVEL",
          "personalLevel",
          150,
          false,
          false
        ),
        cellRenderer: (data) => {
          return UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        },
      },
      {
        headerName: translocoService.translate("WORKFLOW.TASK.LABEL.STAGE"),
        field: "aggStatus",
        minWidth: 250,
        headerClass: "custom-header-group",
        toolPanelClass: 'visible', // Include in tool panel
        cellRenderer: (item) => {
          if (!item.value) {
            return '';
          }
          let returnString = '';
          let status = item?.data?.status;
          let aggStatus = item?.value;
          let statusLabel = '';
          let title = '';
          let hasWaitingAssessReview = false;
          const reqJoinedStatuses = item?.data?.reqJoinedStatuses;
          const joinedStatuses = item?.data?.joinedStatuses;
          if (joinedStatuses && joinedStatuses.includes(REQUEST_CANDIDATE_STATUS.CV_SELECTING)) {
            hasWaitingAssessReview = true;
            statusLabel = convertRequestStatus(REQUEST_STATUS.WAITING_REVIEW, translocoService);
            title += statusLabel + ' ';
            returnString += `<span style="color: #8C62FF">${statusLabel}</span>`;
          }
          if (joinedStatuses && joinedStatuses.includes(REQUEST_CANDIDATE_STATUS.INTERVIEW)) {
            hasWaitingAssessReview = true;
            statusLabel = convertRequestStatus(REQUEST_STATUS.WAITING_ASSESS, translocoService);
            title += statusLabel + ' ';
            returnString += `<span style="color: #E6BB20">${statusLabel}</span>`;
          }
          if (!hasWaitingAssessReview && aggStatus.includes(REQUEST_STATUS.REJECTED)) {
            statusLabel = convertRequestStatus(REQUEST_STATUS.REJECTED, translocoService);
            title += statusLabel + ' ';
            returnString += `<span style="color: #E03137">${statusLabel}</span>`;
          }
          if (reqJoinedStatuses
            && (reqJoinedStatuses.includes(REQUEST_STATUS.WAITING_HRBP)
              || reqJoinedStatuses.includes(REQUEST_STATUS.WAITING_DEPT)
              || reqJoinedStatuses.includes(REQUEST_STATUS.WAITING_RRM))) {
            status = REQUEST_STATUS.WAITING_APPROVE;
            statusLabel = convertRequestStatus(status, translocoService);
            title += statusLabel + ' ';
            returnString += `<span style="color: #2F78EE">${statusLabel}</span>`;
          } else {
            if (REQUEST_STATUS.INPROCESS !== status || (REQUEST_STATUS.INPROCESS === status && !hasWaitingAssessReview)) {
              const color = REQUEST_STATUS.CLOSE == status || REQUEST_STATUS.CANCEL == status ? '#E03137' : '#0BA259';
              statusLabel = convertRequestStatus(status, translocoService);
              title += statusLabel + ' ';
              returnString += `<span style="color: ${color}">${statusLabel}</span>`;
            }
          }
          return `<span class="flex gap-2 body-small-bold custom-cell-truncate" title="${title}">` + returnString + `</span>`;
        },
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "RECRUITMENT.LABEL.QUANTITY",
          "noOfRequest",
          140,
          false,
          false
        ),
        cellRenderer: (data) => {
          if (!data || !data?.value) {
            return "0";
          }
          if (data?.data?.targetValue) {
            return data?.value + " (" + data?.data?.targetValue + ")";
          }
          return data?.value;
        }
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "RECRUITMENT.LABEL.REPORT_TO",
          "reportToData",
          200,
          true,
          false
        ),
        cellStyle: getDefaultStyle(),
        cellRenderer: (data) => {
          if (!data || !data?.value) {
            return "";
          }
          let value = extractUsername(UtilCommon.deepClone([data.value?.email]));
          return value?.length ? value?.[0] : "";
        }
      }
    ]
  }
  return [
    // utilComponent.commonColumnNo("No", "no", 100),
    {
      ...utilComponent.commonColumnAgGrid(
        "WORKFLOW.TASK.LABEL.REQUEST_TYPE",
        "requestType",
        180,
        false,
        false
      ),
      width: 180,
      toolPanelClass: 'visible', // Include in tool panel
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "WORKFLOW.TASK.LABEL.BUSINESS_KEY",
        "code",
        200,
        false,
        false,
      ),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        let hint = '';
        const postFlg = data?.data?.postFlg;
        const postStatus = data?.data?.postStatus;
        if (postFlg && !(PostStatus.DRAFT === postStatus || PostStatus.PENDING === postStatus)) {
          hint = '<span style="color: #FF9800; margin-left: 4px; font-size: 18px;">*</span>'
        }
        let pending = '';
        const pendingFlg = data?.data?.pendingFlg;
        if (pendingFlg) {
          pending = ' <span style="margin-left: 8px; font-style: italic ;font-weight: 700 ;padding: 4px 8px;background: #f52b2b; border-radius: 30px;color: white; font-size: 8px ">Pending</span>';
        }
        return `<span>${data?.value}</span> ${hint}${pending}`;
      },
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.JOB_TITLE"),
      enableRowGroup: true,
      hide: false,
      cellStyle: getDefaultStyle(),
      field: "jobTitle",
      width: 300,
      minWidth: 200,
      // maxWidth: 280,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      },
      // suppressSizeToFit: true,
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "WORKFLOW.TASK.LABEL.LEVEL",
        "personalLevel",
        150,
        false,
        false
      ),
      hide: false,
      maxWidth: 150,
      cellRenderer: (data) => {
        return UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
      },
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.STAGE"),
      field: "aggStatus",
      minWidth: 250,
      headerClass: "custom-header-group",
      toolPanelClass: 'visible', // Include in tool panel
      cellRenderer: (item) => {
        if (!item.value) {
          return '';
        }
        let returnString = '';
        let status = item?.data?.status;
        let aggStatus = item?.value;
        let statusLabel = '';
        let title = '';
        let hasWaitingAssessReview = false;
        const reqJoinedStatuses = item?.data?.reqJoinedStatuses;
        const joinedStatuses = item?.data?.joinedStatuses;
        if (joinedStatuses && joinedStatuses.includes(REQUEST_CANDIDATE_STATUS.CV_SELECTING)) {
          hasWaitingAssessReview = true;
          statusLabel = convertRequestStatus(REQUEST_STATUS.WAITING_REVIEW, translocoService);
          title += statusLabel + ' ';
          returnString += `<span style="color: #8C62FF">${statusLabel}</span>`;
        }
        if (joinedStatuses && joinedStatuses.includes(REQUEST_CANDIDATE_STATUS.INTERVIEW)) {
          hasWaitingAssessReview = true;
          statusLabel = convertRequestStatus(REQUEST_STATUS.WAITING_ASSESS, translocoService);
          title += statusLabel + ' ';
          returnString += `<span style="color: #E6BB20">${statusLabel}</span>`;
        }
        if (!hasWaitingAssessReview && aggStatus.includes(REQUEST_STATUS.REJECTED)) {
          statusLabel = convertRequestStatus(REQUEST_STATUS.REJECTED, translocoService);
          title += statusLabel + ' ';
          returnString += `<span style="color: #E03137">${statusLabel}</span>`;
        }
        if (reqJoinedStatuses
          && (reqJoinedStatuses.includes(REQUEST_STATUS.WAITING_HRBP)
            || reqJoinedStatuses.includes(REQUEST_STATUS.WAITING_DEPT)
            || reqJoinedStatuses.includes(REQUEST_STATUS.WAITING_RRM))) {
          status = REQUEST_STATUS.WAITING_APPROVE;
          statusLabel = convertRequestStatus(status, translocoService);
          title += statusLabel + ' ';
          returnString += `<span style="color: #2F78EE">${statusLabel}</span>`;
        } else {
          if (REQUEST_STATUS.INPROCESS !== status || (REQUEST_STATUS.INPROCESS === status && !hasWaitingAssessReview)) {
            const color = REQUEST_STATUS.CLOSE == status || REQUEST_STATUS.CANCEL == status ? '#E03137' : '#0BA259';
            statusLabel = convertRequestStatus(status, translocoService);
            title += statusLabel + ' ';
            returnString += `<span style="color: ${color}">${statusLabel}</span>`;
          }
        }
        return `<span class="flex gap-2 body-small-bold custom-cell-truncate" title="${title}">` + returnString + `</span>`;
      },
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "RECRUITMENT.LABEL.QUANTITY",
        "noOfRequest",
        140,
        false,
        false
      ),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "0";
        }
        if (data?.data?.targetValue) {
          return data?.value + " (" + data?.data?.targetValue + ")";
        }
        return data?.value;
      },
      minWidth: 140,
      maxWidth: 300,
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "RECRUITMENT.LABEL.REPORT_TO",
        "reportToData",
        200,
        true,
        false
      ),
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        let value = extractUsername(UtilCommon.deepClone([data.value?.email]));
        return value?.length ? value?.[0] : "";
      },
      maxWidth: 350,
      minWidth: 200,
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "WORKFLOW.TASK.LABEL.HANDLE_BY",
        "handleBy",
        200,
        true,
        false
      ),
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }

        let value = extractUsername(UtilCommon.deepClone(data.value?.split(',')));
        let result = value?.length ? value?.[0] : "";
        return `<div class="custom-cell-truncate" title="${value?.join(", ") || ""}">${result}</div>`;
      }
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.PLACE"),
      field: "place",
      minWidth: 250,
      cellRenderer: (data) => {
        return UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
      },
    },
  ];
};

export function convertRequestStatus(status: string, translocoService: TranslocoService) {
  if (!status) {
    return '';
  }
  if (REQUEST_STATUS.DRAFT === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.DRAFT");
  } else if (REQUEST_STATUS.WAITING_HRBP === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.WAITING_HRBP");
  } else if (REQUEST_STATUS.WAITING_DEPT === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.WAITING_DEPT");
  } else if (REQUEST_STATUS.WAITING_RRM === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.WAITING_RRM");
  } else if (REQUEST_STATUS.INPROCESS === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.INPROCESS");
  } else if (REQUEST_STATUS.DONE === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.DONE");
  } else if (REQUEST_STATUS.CLOSE === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.CLOSE");
  } else if (REQUEST_STATUS.CANCEL === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.CANCEL");
  } else if (REQUEST_STATUS.WAITING_APPROVE === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.WAITING_APPROVE");
  } else if (REQUEST_STATUS.WAITING_ASSESS === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.WAITING_ASSESS");
  } else if (REQUEST_STATUS.WAITING_REVIEW === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.WAITING_REVIEW");
  } else if (REQUEST_STATUS.REJECTED === status.toUpperCase()) {
    status = translocoService.translate("RECRUITMENT.STATUS.REJECTED");
  } else {
    status = UtilCommon.capitalizeFirstCharacterOfWords(status);
  }
  status = UtilCommon.capitalizeFirstCharacterOfWords(status);
  return status;
}

export const getCommonColumnMyDraft = (
  utilComponent: UtilComponent,
  translocoService: TranslocoService,
  enbaleDefaultRowGroup: boolean = false
) => {
  return [
    utilComponent.commonColumnNo("No", "no", 100),
    {
      ...utilComponent.commonColumnAgGrid(
        "WORKFLOW.TASK.LABEL.REQUEST_TYPE",
        "requestType",
        180,
        false,
        false
      ),
      // hide: true,
      maxWidth: 250
    },
    {
      headerName: translocoService.translate("RECRUITMENT.LABEL.REQUEST_FOR_COMPANY"),
      enableRowGroup: true,
      hide: false,
      cellStyle: getDefaultStyle(),
      field: "requestForCompany",
      width: 250,
      minWidth: 250,
      maxWidth: 350,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      },
      suppressSizeToFit: true,
      // rowGroup: enbaleDefaultRowGroup
    },
    {
      headerName: translocoService.translate("RECRUITMENT.LABEL.REQUEST_FOR_DEPARTMENT"),
      hide: false,
      cellStyle: getDefaultStyle(),
      field: "requestForDepartment",
      width: 250,
      minWidth: 250,
      maxWidth: 350,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.displayPath || data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      },
      suppressSizeToFit: true,
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.JOB_TITLE"),
      enableRowGroup: true,
      hide: false,
      cellStyle: getDefaultStyle(),
      field: "jobTitle",
      width: 200,
      minWidth: 200,
      maxWidth: 350,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      },
      suppressSizeToFit: true,
    },
    {
      headerName: translocoService.translate("RECRUITMENT.LABEL.WORKING_PLACE"),
      enableRowGroup: true,
      hide: false,
      cellStyle: getDefaultStyle(),
      field: "workingPlace",
      width: 200,
      minWidth: 200,
      maxWidth: 350,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      },
      suppressSizeToFit: true,
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "RECRUITMENT.LABEL.REPORT_TO",
        "reportToData",
        200,
        false,
        false
      ),
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        let value = extractUsername(UtilCommon.deepClone([data.value?.email]));
        return value?.length ? value?.[0] : "";
      },
      maxWidth: 350,
      minWidth: 200,
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "RECRUITMENT.LABEL.REQUEST_QUANTITY",
        "noOfRequest",
        140,
        false,
        false
      ),
      filter: 'agNumberColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      minWidth: 140,
      maxWidth: 300,
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "GENERAL.MAKER_DATE",
        "createDate",
        200,
        false,
        false
      ),
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.formatDateFullTime(data.value);
      },
      minWidth: 200,
      maxWidth: 200,
    }
  ];
};

export enum CallBackActionColumn {
  VIEW_ORIGINAL_CV = "VIEW_ORIGINAL_CV",
  VIEW_NOMALIZED_CV = "VIEW_NOMALIZED_CV",
  VIEW_CV = "VIEW_CV",
  VIEW_DATA_AI = "VIEW_DATA_AI"
}

export const getColumnOnlineCandidate = (
  utilComponent: UtilComponent,
  translocoService: TranslocoService,
  callBackAction: (event: CallBackActionColumn, extraValue: { [key: string]: any }) => void
) => {
  return [
    {
      headerName: '',
      field: 'id',
      cellRenderer: 'draftCheckboxRenderer', // Sử dụng cellRenderer cho từng dòng
      headerComponent: 'draftHeaderCheckbox',  // Sử dụng `mat-checkbox` cho header
      // width: 80,
      // resizable: false
    },
    {
      ...utilComponent.commonColumnNo("No", "no", null),
      // minWidth: 100,
    },
    {
      headerName: translocoService.translate('CANDIDATE.LIST.VIEW_CV'),
      field: "id",
      cellRenderer: () => {
        const tooltip = translocoService.translate("CANDIDATE.LABEL.ACTON_VIEW");
        const result = '<svg fill="#ED5A26" width="20px" height="20px" viewBox="0 0 846.66 846.66" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M539.75 794.68c27.15,0 27.15,41.29 0,41.29l-497.47 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -621.69c0,-5.7 2.31,-10.87 6.04,-14.6l162.3 -162.29c4.03,-4.03 9.31,-6.05 14.59,-6.05l466.89 0c11.4,0 20.65,9.25 20.65,20.65l0 361.36c0,27.16 -41.29,27.16 -41.29,0l0 -340.72 -437.7 0 -150.19 150.2 0 592.5 476.82 0zm-351.21 -181.98c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm496.57 238.25c49.84,0 90.24,40.4 90.24,90.24 0,18.1 -5.33,34.95 -14.5,49.07 37.57,24.93 61.47,66.08 64.13,111.2 1.59,27.06 -39.55,29.47 -41.13,2.42 -2.11,-35.69 -22.61,-67.48 -54.13,-84.24 -13.16,7.5 -28.38,11.78 -44.61,11.78 -17.56,0 -33.95,-5.01 -47.81,-13.69 -33.44,16.12 -55.6,49.04 -57.79,86.15 -1.59,27.05 -42.72,24.64 -41.13,-2.42 2.79,-47.18 28.75,-89.88 69.08,-114.28 -7.99,-13.47 -12.58,-29.19 -12.58,-45.99 0,-49.83 40.4,-90.24 90.23,-90.24zm0 41.29c-27.03,0 -48.94,21.92 -48.94,48.95 0,27.03 21.91,48.94 48.94,48.94 27.03,0 48.95,-21.91 48.95,-48.94 0,-27.03 -21.91,-48.95 -48.95,-48.95z"></path> </g> </g></svg>'
        return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
      },
      // width: 80,
      // width: 120,
      sortable: false,
      // resizable: false,
      // suppressMenu: true,
      // cellClass: () => 'flex pl-4',
      onCellClicked: (item: any) => {
        callBackAction(CallBackActionColumn.VIEW_CV, item?.data?.cvInfo);
        item?.preventDefault?.();
      },
      // tooltipValueGetter: (p: ITooltipParams) => {
      //   const firstLabel = translocoService.translate("CANDIDATE.LABEL.ACTON_VIEW");
      //   return firstLabel + " " + UtilCommon.getValueByLanguage(p?.data?.candidateFullName?.value);
      // },
    },
    {
      headerName: translocoService.translate('CANDIDATE.LIST.VIEW_DATA_AI'),
      field: "extractedInfo",
      // cellClass: () => 'flex pl-4',
      cellRenderer: (data) => {
        const jsonValue = data?.data?.extractedInfo?.value;
        if (!jsonValue) {
          return '';
        }
        const value = JSON.parse(jsonValue);
        const originalData = value?.originalData;
        const matchingData = value?.matchingData;
        if (!originalData && !matchingData) {
          return '';
        }
        const tooltip = translocoService.translate("CANDIDATE.LABEL.VIEW_DATA_AI");
        const result = '<svg width="20px" height="20px" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" fill="#000000" viewBox="0 0 846.66 846.66" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M174.61 513.03l0 -481.99c0,-11.4 9.24,-20.64 20.64,-20.64l458.76 0c87.86,0 159.66,71.8 159.66,159.66l0 503.93c0,11.41 -9.24,20.65 -20.64,20.65l-436.81 0c-10.26,80.85 -79.33,141.62 -160.97,141.62 -89.61,0 -162.26,-72.65 -162.26,-162.27 0,-81.63 60.78,-150.7 141.62,-160.96zm-59.12 194.24c-19.2,-19.2 10,-48.39 29.2,-29.19l28.09 28.09 70.38 -108.12c14.72,-22.67 49.24,-0.25 34.52,22.42l-83.38 128.07c-6.51,12.05 -22.93,14.61 -32.76,4.78l-46.05 -46.05zm240.73 -53.92l416.16 0 0 -483.29c0,-65.06 -53.31,-118.37 -118.37,-118.37l-438.11 0 0 461.34c73.1,9.28 131.04,67.21 140.32,140.32zm-160.97 -100.33c-66.81,0 -120.97,54.16 -120.97,120.97 0,66.82 54.16,120.98 120.97,120.98 66.82,0 120.98,-54.16 120.98,-120.98 0,-66.81 -54.16,-120.97 -120.98,-120.97zm428.34 -254.17l92.1 0c11.4,0 20.64,9.25 20.64,20.65l0 217.21c0,11.4 -9.24,20.65 -20.64,20.65l-92.1 0c-11.4,0 -20.65,-9.25 -20.65,-20.65l0 -217.21c0,-11.4 9.25,-20.65 20.65,-20.65zm71.45 41.29l-50.81 0 0 175.92 50.81 0 0 -175.92zm-170.49 -163.34c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm0 69.51c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm-255.44 218.95c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.3 0,-41.3l205.04 0c27.16,0 27.16,41.3 0,41.3l-205.04 0zm4.34 -253.29l152.92 0c11.4,0 20.64,9.24 20.64,20.64l0 152.92c0,11.4 -9.24,20.65 -20.64,20.65l-152.92 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -152.92c0,-11.4 9.24,-20.64 20.64,-20.64zm132.27 41.29l-111.62 0 0 111.63 111.62 0 0 -111.63z"></path> </g> </g></svg>'
        return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
      },
      // width: 80,
      // width: 120,
      sortable: false,
      // resizable: false,
      // suppressMenu: true,
      onCellClicked: (item: any) => {
        callBackAction(CallBackActionColumn.VIEW_DATA_AI, item?.data?.extractedInfo);
        item?.preventDefault?.();
      },
      // tooltipValueGetter: (p: ITooltipParams) => {
      //   const firstLabel = translocoService.translate("CANDIDATE.LABEL.VIEW_DATA_AI");
      //   return firstLabel + " " + UtilCommon.getValueByLanguage(p?.data?.candidateFullName?.value);
      // },
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.FULL_NAME"),
      cellStyle: getDefaultStyle(),
      field: "candidateFullName",
      // width: 200,
      // minWidth: 200,
      cellRenderer: (data) => {
        const parsedValue = !!data?.value?.value ? JSON.parse(data?.value?.value) : ''
        let result = UtilCommon.getLabelLanguage(parsedValue) || "";
        return result;
      },
      // flex: 1
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.EMAIL"),
      field: "candidateEmail",
      // minWidth: 250,
      // width: 250
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.MOBILE"),
      field: "candidatePhone",
      // minWidth: 150,
      // width: 150
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.SOURCE"),
      field: "sourceName",
      cellRenderer: (item) => {
        const parsedValue = !!item?.value?.value ? JSON.parse(item?.value?.value) : ''
        return UtilCommon.getValueByLanguage(parsedValue);
      },
      // width: 120,
      // maxWidth: 200,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.RECOMMENDER"),
      field: "recommenderEmail",
      cellRenderer: (item) => {
        return item?.value?.split("@")?.[0]
      },
      // width: 150,
      // maxWidth: 250,
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.APPLY_DATE"),
      field: "candidateApplyDate",
      cellRenderer: (item) => {
        return item?.value ? UtilCommon.formatDate(item?.value) : "";
      },
      // minWidth: 200,
      // width: 200
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.MATCHING_DATE"),
      field: "matchingDate",
      cellRenderer: (item) => {
        return item?.value ? UtilCommon.formatDate(item?.value) : "";
      },
      // minWidth: 200,
      // width: 200
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.STATUS"),
      field: "candidateStatus",
      // minWidth: 150,
      // width: 150,
      cellRenderer: (item) => {
        if (!item.value) {
          return '';
        }
        return UtilCommon.capitalizeFirstCharacterOfWords(UtilCommon.convertOnlineCandidateResume(item.value));
      },
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.HANDLE_BY"),
      field: "handleBy",
      // minWidth: 150,
      // width: 150,
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getNameFromEmail(data.value);
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LIST.MACTHING_STATUS"),
      field: "hiringProcessStatus",
      // minWidth: 180,
      // width: 180,
      cellRenderer: (item) => {
        return UtilCommon.capitalizeFirstCharacterOfWords(item.value);
      },
    }
  ];
}

function getToolColumnRequestCandidate(data: any, result: any, translocoService: TranslocoService): any {
  if (REQUISITION_CANDIDATE_TASK_STATUS.PROCESSING === data?.data?.taskStatus
    || (REQUEST_CANDIDATE_TASK_KEY.WAITING_RR_SCREENING === data?.data?.taskKey
      && !data?.data?.taskId)) {
    const tooltip = translocoService.translate("WORKFLOW.TASK.MESSAGE.TASK.PROCESSING");
    return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
  } else if (REQUEST_CANDIDATE_STATUS.DONE === data.data?.reqCandidateStatus) {
    const tooltip = translocoService.translate("CANDIDATE.REQUISITION_CANDIDATE_STATUS.DONE");
    return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
  } else if (REQUEST_CANDIDATE_STATUS.CLOSE === data.data?.reqCandidateStatus
    || REQUEST_CANDIDATE_STATUS.FAIL === data.data?.reqCandidateStatus
    || REQUEST_CANDIDATE_STATUS.CANCEL === data.data?.reqCandidateStatus) {
    const tooltip = translocoService.translate("CANDIDATE.REQUISITION_CANDIDATE_STATUS.CLOSE.FAIL.CANCEL");
    return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
  } else if (data?.data?.keepInViewFlg) {
    const tooltip = translocoService.translate("WORKFLOW.TASK.BUTTON.KEEP_IN_VIEW");
    return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
  } else if (data.data?.scanState && data.data?.scanState.toLowerCase().includes('fail')) {
    const tooltip = UtilCommon.escapeHtml(data.data?.scanLog) || data.data?.scanState;
    return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
  } else if (data.data?.transfercnbStatus && data.data?.transfercnbStatus.toLowerCase().includes('fail')) {
    const tooltip = UtilCommon.escapeHtml(data.data?.transfercnbMessage) || data.data?.transfercnbStatus;
    return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
  }
  return result;
}

export const getColumnRequestCandidate = (
  utilComponent: UtilComponent,
  translocoService: TranslocoService,
  callBackAction: (event: CallBackActionColumn, extraValue: { [key: string]: any }) => void,
  permissionRR: boolean = false
) => {
  // Not RR/RRM
  if (!permissionRR) {
    return [
      {
        headerName: 'Select',
        field: 'id',
        cellRenderer: 'matCheckboxRenderer', // Sử dụng cellRenderer cho từng dòng
        headerComponent: 'matHeaderCheckbox',  // Sử dụng `mat-checkbox` cho header
        width: 60,
      },
      {
        headerName: translocoService.translate("CANDIDATE.LABEL.FULL_NAME"),
        cellStyle: getDefaultStyle(),
        field: "fullName",
        flex: 1,
        // width: 250,
        // minWidth: 250,
        cellRenderer: (data) => {
          const result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
          return getToolColumnRequestCandidate(data, result, translocoService);
        }
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "CANDIDATE.LABEL.REQ_STATUS",
          "displayStatus",
          300,
          false,
          true
        ),
        cellRenderer: (data) => {
          let status = UtilCommon.getLabelLanguage(data.data?.displayStatus || data?.value?.label || data?.value?.name || data?.value || data.data?.reqCandidateStatus) || "";
          let statusLabel = '';
          const joinedStatuses = data?.data?.joinedStatuses;
          if (joinedStatuses && joinedStatuses.includes(REQUEST_CANDIDATE_STATUS.CV_SELECTING)) {
            statusLabel = convertRequestStatus(REQUEST_STATUS.WAITING_REVIEW, translocoService);
            return `<span class="flex gap-2 body-small-bold custom-cell-truncate" style="color: #8C62FF" title="${statusLabel}">${statusLabel}</span>`;
          } else if (joinedStatuses && joinedStatuses.includes(REQUEST_CANDIDATE_STATUS.INTERVIEW)) {
            statusLabel = convertRequestStatus(REQUEST_STATUS.WAITING_ASSESS, translocoService);
            return `<span class="flex gap-2 body-small-bold custom-cell-truncate" style="color: #E6BB20" title="${statusLabel}">${statusLabel}</span>`;
          } else {
            status = UtilCommon.capitalizeFirstCharacterOfWords(status);
            return getToolColumnRequestCandidate(data, status, translocoService);
            // return `<span class="flex gap-2 body-small-bold custom-cell-truncate">${getToolColumnRequestCandidate(data, status, translocoService)}</span>`;
          }
        }
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "CANDIDATE.LABEL.DECISION",
          "decision",
          150,
          false,
          true
        ),
        cellRenderer: (data) => {
          if (!data || !data?.value) {
            return "";
          }
          const result = UtilCommon.capitalizeFirstCharacterOfWords(data.value);
          return getToolColumnRequestCandidate(data, result, translocoService);
        }
      },
      {
        ...utilComponent.commonColumnAgGrid(
          "CANDIDATE.LABEL.MATCHING_DATE",
          "matchingDate",
          250,
          false,
          false
        ),
        filter: 'agDateColumnFilter',
        filterParams: {
          applyButton: true,
          newRowsAction: 'keep'
        },
        cellStyle: getDefaultStyle(),
        cellRenderer: (data) => {
          if (!data || !data?.value) {
            return "";
          }
          const result = UtilCommon.formatDate(data.value);
          return getToolColumnRequestCandidate(data, result, translocoService);
        },
        minWidth: 200
      },
    ];
  }
  return [
    {
      headerName: 'Select',
      field: 'id',
      cellRenderer: 'matCheckboxRenderer', // Sử dụng cellRenderer cho từng dòng
      headerComponent: 'matHeaderCheckbox',  // Sử dụng `mat-checkbox` cho header
      width: 60,
    },
    utilComponent.commonColumnNo("No", "no", 100),
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.SOURCE",
        "source",
        180,
        false,
        true
      ),
      hide: true,
      // rowGroup: enbaleDefaultRowGroup
      cellRenderer: (data) => {
        const result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return getToolColumnRequestCandidate(data, result, translocoService);
      }
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.SOURCE_TYPE",
        "sourceType",
        180,
        false,
        true
      ),
      hide: true,
      // rowGroup: enbaleDefaultRowGroup
      cellRenderer: (data) => {
        const result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return getToolColumnRequestCandidate(data, result, translocoService);
      }
    },
    {
      headerName: translocoService.translate('CANDIDATE.LIST.VIEW_CV'),
      field: "attachmentRefno",
      enableRowGroup: false,
      cellRenderer: (data) => {
        if (data.value) {
          const firstLabel = translocoService.translate("CANDIDATE.LABEL.VIEW_ORIGINAL_CV");
          // const tooltip = firstLabel + " " + UtilCommon.getLabelLanguage(data?.data?.fullName?.label || data?.data?.fullName?.name || data?.data?.fullName) || "";
          const tooltip = firstLabel;
          const result = '<svg fill="#ED5A26" width="20px" height="20px" viewBox="0 0 846.66 846.66" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M539.75 794.68c27.15,0 27.15,41.29 0,41.29l-497.47 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -621.69c0,-5.7 2.31,-10.87 6.04,-14.6l162.3 -162.29c4.03,-4.03 9.31,-6.05 14.59,-6.05l466.89 0c11.4,0 20.65,9.25 20.65,20.65l0 361.36c0,27.16 -41.29,27.16 -41.29,0l0 -340.72 -437.7 0 -150.19 150.2 0 592.5 476.82 0zm-351.21 -181.98c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm496.57 238.25c49.84,0 90.24,40.4 90.24,90.24 0,18.1 -5.33,34.95 -14.5,49.07 37.57,24.93 61.47,66.08 64.13,111.2 1.59,27.06 -39.55,29.47 -41.13,2.42 -2.11,-35.69 -22.61,-67.48 -54.13,-84.24 -13.16,7.5 -28.38,11.78 -44.61,11.78 -17.56,0 -33.95,-5.01 -47.81,-13.69 -33.44,16.12 -55.6,49.04 -57.79,86.15 -1.59,27.05 -42.72,24.64 -41.13,-2.42 2.79,-47.18 28.75,-89.88 69.08,-114.28 -7.99,-13.47 -12.58,-29.19 -12.58,-45.99 0,-49.83 40.4,-90.24 90.23,-90.24zm0 41.29c-27.03,0 -48.94,21.92 -48.94,48.95 0,27.03 21.91,48.94 48.94,48.94 27.03,0 48.95,-21.91 48.95,-48.94 0,-27.03 -21.91,-48.95 -48.95,-48.95z"></path> </g> </g></svg>'
          return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
        }
      },
      minWidth: 100,
      sortable: false,
      // resizable: false,
      // suppressMenu: true,
      onCellClicked: (event: any) => {
        callBackAction(CallBackActionColumn.VIEW_ORIGINAL_CV, {
          data: event?.data,
        });
      },
      // tooltipValueGetter: (p: ITooltipParams) => {
      //   const firstLabel = translocoService.translate("CANDIDATE.LABEL.VIEW_ORIGINAL_CV");
      //   return firstLabel + " " + UtilCommon.getLabelLanguage(p?.data?.fullName?.label || p?.data?.fullName?.name || p?.data?.fullName) || "";
      // },
    },
    {
      headerName: translocoService.translate('CANDIDATE.LABEL.NOMALIZED_CV'),
      field: "nomalizedAttachmentRefno",
      enableRowGroup: false,
      cellRenderer: (data) => {
        // if (data.value) {
        const firstLabel = translocoService.translate("CANDIDATE.LABEL.VIEW_NOMALIZED_CV");
        const tooltip = firstLabel;
        const result = '<svg width="20px" height="20px" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" fill="#000000" viewBox="0 0 846.66 846.66" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M174.61 513.03l0 -481.99c0,-11.4 9.24,-20.64 20.64,-20.64l458.76 0c87.86,0 159.66,71.8 159.66,159.66l0 503.93c0,11.41 -9.24,20.65 -20.64,20.65l-436.81 0c-10.26,80.85 -79.33,141.62 -160.97,141.62 -89.61,0 -162.26,-72.65 -162.26,-162.27 0,-81.63 60.78,-150.7 141.62,-160.96zm-59.12 194.24c-19.2,-19.2 10,-48.39 29.2,-29.19l28.09 28.09 70.38 -108.12c14.72,-22.67 49.24,-0.25 34.52,22.42l-83.38 128.07c-6.51,12.05 -22.93,14.61 -32.76,4.78l-46.05 -46.05zm240.73 -53.92l416.16 0 0 -483.29c0,-65.06 -53.31,-118.37 -118.37,-118.37l-438.11 0 0 461.34c73.1,9.28 131.04,67.21 140.32,140.32zm-160.97 -100.33c-66.81,0 -120.97,54.16 -120.97,120.97 0,66.82 54.16,120.98 120.97,120.98 66.82,0 120.98,-54.16 120.98,-120.98 0,-66.81 -54.16,-120.97 -120.98,-120.97zm428.34 -254.17l92.1 0c11.4,0 20.64,9.25 20.64,20.65l0 217.21c0,11.4 -9.24,20.65 -20.64,20.65l-92.1 0c-11.4,0 -20.65,-9.25 -20.65,-20.65l0 -217.21c0,-11.4 9.25,-20.65 20.65,-20.65zm71.45 41.29l-50.81 0 0 175.92 50.81 0 0 -175.92zm-170.49 -163.34c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm0 69.51c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm-255.44 218.95c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.3 0,-41.3l205.04 0c27.16,0 27.16,41.3 0,41.3l-205.04 0zm4.34 -253.29l152.92 0c11.4,0 20.64,9.24 20.64,20.64l0 152.92c0,11.4 -9.24,20.65 -20.64,20.65l-152.92 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -152.92c0,-11.4 9.24,-20.64 20.64,-20.64zm132.27 41.29l-111.62 0 0 111.63 111.62 0 0 -111.63z"></path> </g> </g></svg>'
        return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
        // }
      },
      minWidth: 150,
      sortable: false,
      // resizable: false,
      // suppressMenu: true,
      onCellClicked: (event: any) => {
        callBackAction(CallBackActionColumn.VIEW_NOMALIZED_CV, {
          data: event?.data,
        });
      },
      // tooltipValueGetter: (p: ITooltipParams) => {
      //   const firstLabel = translocoService.translate("CANDIDATE.LABEL.VIEW_NOMALIZED_CV");
      //   return firstLabel + " " + UtilCommon.getLabelLanguage(p?.data?.fullName?.label || p?.data?.fullName?.name || p?.data?.fullName) || "";
      // },
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.FULL_NAME"),
      cellStyle: getDefaultStyle(),
      field: "fullName",
      width: 250,
      minWidth: 250,
      cellRenderer: (data) => {
        const result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return getToolColumnRequestCandidate(data, result, translocoService);
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.GENDER"),
      hide: true,
      enableRowGroup: true,
      cellStyle: getDefaultStyle(),
      field: "gender",
      width: 150,
      minWidth: 100,
      cellRenderer: (data) => {
        const result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return getToolColumnRequestCandidate(data, result, translocoService);
      },
      suppressSizeToFit: true
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.DOB",
        "dob",
        200,
        false,
        false
      ),
      hide: false,
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.formatDate(data.value);
        return getToolColumnRequestCandidate(data, result, translocoService);
      },
      width: 200,
      minWidth: 200
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.EMAIL",
        "personalEmail",
        250,
        true,
        false
      ),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = data?.value;
        return getToolColumnRequestCandidate(data, result, translocoService);
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.MOBILE"),
      field: "mobile",
      width: 150
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.REQ_STATUS",
        "displayStatus",
        220,
        false,
        true
      ),
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data.data?.displayStatus || data?.value?.label || data?.value?.name || data?.value || data.data?.reqCandidateStatus) || "";
        result = UtilCommon.capitalizeFirstCharacterOfWords(result);
        return getToolColumnRequestCandidate(data, result, translocoService);
      }
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.DECISION",
        "decision",
        150,
        false,
        true
      ),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.capitalizeFirstCharacterOfWords(data.value);
        return getToolColumnRequestCandidate(data, result, translocoService);
      }
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.APPLY_DATE",
        "applyDate",
        200,
        false,
        false
      ),
      // hide: true,
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.formatDate(data.value);
        return getToolColumnRequestCandidate(data, result, translocoService);
      },
      width: 200,
      minWidth: 200
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.MATCH_ID",
        "makerId",
        150,
        false,
        false
      ),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.getNameFromEmail(data.value);
        return getToolColumnRequestCandidate(data, result, translocoService);
      },
      minWidth: 150
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.MATCHING_DATE",
        "matchingDate",
        200,
        false,
        false
      ),
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.formatDate(data.value);
        return getToolColumnRequestCandidate(data, result, translocoService);
      },
      minWidth: 200
    },
    // {
    //   headerName: translocoService.translate("CANDIDATE.LABEL.IS_DIRECT_ERP"),
    //   field: "directErpFlg",
    //   enableRowGroup: false,
    //   width: 180,
    //   cellRenderer: 'statusRendererComponent'
    // },
    {
      ...utilComponent.commonColumnAgGrid(
        "GENERAL.UPDATE_ID",
        "updateId",
        150,
        false,
        false
      ),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getNameFromEmail(data.value);
      },
      minWidth: 150
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "GENERAL.UPDATE_DATE",
        "updateDate",
        200,
        false,
        false
      ),
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.formatDateFullTime(data.value);
      },
      minWidth: 200
    }
  ];
};

export const getColumnRequestAssignment = (
  utilComponent: UtilComponent,
  translocoService: TranslocoService,
  callBackAction: (event: CallBackActionColumn, extraValue: { [key: string]: any }) => void
) => {
  return [
    utilComponent.commonColumnNo("No", "no", 100),
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.ASSIGNMENT"),
      field: "attachmentDetails",
      enableRowGroup: false,
      cellRenderer: (data) => {
        const parsedValue = !!data?.value?.value ? JSON.parse(data?.value?.value) : [];
        if (UtilCommon.isArray(parsedValue, true)) {
          const attachment = parsedValue.find(item => item.attachment_type_code === AttachmentCode.ASSIGNMENT) || null;
          if (attachment) {
            const tooltip = translocoService.translate("WORKFLOW.TASK.LABEL.ASSIGNMENT");
            const result = '<svg fill="#ED5A26" width="20px" height="20px" viewBox="0 0 846.66 846.66" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M539.75 794.68c27.15,0 27.15,41.29 0,41.29l-497.47 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -621.69c0,-5.7 2.31,-10.87 6.04,-14.6l162.3 -162.29c4.03,-4.03 9.31,-6.05 14.59,-6.05l466.89 0c11.4,0 20.65,9.25 20.65,20.65l0 361.36c0,27.16 -41.29,27.16 -41.29,0l0 -340.72 -437.7 0 -150.19 150.2 0 592.5 476.82 0zm-351.21 -181.98c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 91.56c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm0 -274.68c-27.16,0 -27.16,-41.29 0,-41.29l306.67 0c27.16,0 27.16,41.29 0,41.29l-306.67 0zm496.57 238.25c49.84,0 90.24,40.4 90.24,90.24 0,18.1 -5.33,34.95 -14.5,49.07 37.57,24.93 61.47,66.08 64.13,111.2 1.59,27.06 -39.55,29.47 -41.13,2.42 -2.11,-35.69 -22.61,-67.48 -54.13,-84.24 -13.16,7.5 -28.38,11.78 -44.61,11.78 -17.56,0 -33.95,-5.01 -47.81,-13.69 -33.44,16.12 -55.6,49.04 -57.79,86.15 -1.59,27.05 -42.72,24.64 -41.13,-2.42 2.79,-47.18 28.75,-89.88 69.08,-114.28 -7.99,-13.47 -12.58,-29.19 -12.58,-45.99 0,-49.83 40.4,-90.24 90.23,-90.24zm0 41.29c-27.03,0 -48.94,21.92 -48.94,48.95 0,27.03 21.91,48.94 48.94,48.94 27.03,0 48.95,-21.91 48.95,-48.94 0,-27.03 -21.91,-48.95 -48.95,-48.95z"></path> </g> </g></svg>'
            return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`;
          }
        }
      },
      width: 150,
      minWidth: 150,
      sortable: false,
      // resizable: false,
      // suppressMenu: true,
      onCellClicked: (event: any) => {
        callBackAction(CallBackActionColumn.VIEW_ORIGINAL_CV, {
          data: event?.data,
        });
      },
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.RESULT"),
      field: "attachmentDetails",
      enableRowGroup: false,
      cellRenderer: (data) => {
        const parsedValue = !!data?.value?.value ? JSON.parse(data?.value?.value) : [];
        if (UtilCommon.isArray(parsedValue, true)) {
          const attachment = parsedValue.find(item => item.attachment_type_code === AttachmentCode.ASSIGNMENT_RESULT) || null;
          if (attachment) {
            const tooltip = translocoService.translate("WORKFLOW.TASK.LABEL.RESULT");
            const result = '<svg width="20px" height="20px" style="cursor:pointer ;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" fill="#000000" viewBox="0 0 846.66 846.66" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <defs> <style type="text/css">  .fil0 {fill:black;fill-rule:nonzero}  </style> </defs> <g id="Layer_x0020_1"> <path class="fil0" d="M174.61 513.03l0 -481.99c0,-11.4 9.24,-20.64 20.64,-20.64l458.76 0c87.86,0 159.66,71.8 159.66,159.66l0 503.93c0,11.41 -9.24,20.65 -20.64,20.65l-436.81 0c-10.26,80.85 -79.33,141.62 -160.97,141.62 -89.61,0 -162.26,-72.65 -162.26,-162.27 0,-81.63 60.78,-150.7 141.62,-160.96zm-59.12 194.24c-19.2,-19.2 10,-48.39 29.2,-29.19l28.09 28.09 70.38 -108.12c14.72,-22.67 49.24,-0.25 34.52,22.42l-83.38 128.07c-6.51,12.05 -22.93,14.61 -32.76,4.78l-46.05 -46.05zm240.73 -53.92l416.16 0 0 -483.29c0,-65.06 -53.31,-118.37 -118.37,-118.37l-438.11 0 0 461.34c73.1,9.28 131.04,67.21 140.32,140.32zm-160.97 -100.33c-66.81,0 -120.97,54.16 -120.97,120.97 0,66.82 54.16,120.98 120.97,120.98 66.82,0 120.98,-54.16 120.98,-120.98 0,-66.81 -54.16,-120.97 -120.98,-120.97zm428.34 -254.17l92.1 0c11.4,0 20.64,9.25 20.64,20.65l0 217.21c0,11.4 -9.24,20.65 -20.64,20.65l-92.1 0c-11.4,0 -20.65,-9.25 -20.65,-20.65l0 -217.21c0,-11.4 9.25,-20.65 20.65,-20.65zm71.45 41.29l-50.81 0 0 175.92 50.81 0 0 -175.92zm-170.49 -163.34c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm0 69.51c-27.16,0 -27.16,-41.29 0,-41.29l156.39 0c27.16,0 27.16,41.29 0,41.29l-156.39 0zm-255.44 218.95c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.29 0,-41.29l284.98 0c27.15,0 27.15,41.29 0,41.29l-284.98 0zm0 -59.08c-27.16,0 -27.16,-41.3 0,-41.3l205.04 0c27.16,0 27.16,41.3 0,41.3l-205.04 0zm4.34 -253.29l152.92 0c11.4,0 20.64,9.24 20.64,20.64l0 152.92c0,11.4 -9.24,20.65 -20.64,20.65l-152.92 0c-11.4,0 -20.64,-9.25 -20.64,-20.65l0 -152.92c0,-11.4 9.24,-20.64 20.64,-20.64zm132.27 41.29l-111.62 0 0 111.63 111.62 0 0 -111.63z"></path> </g> </g></svg>'
            return `<div class="custom-cell-truncate" title="${tooltip}">${result}</div>`
          }
        }
      },
      width: 150,
      minWidth: 150,
      sortable: false,
      // resizable: false,
      // suppressMenu: true,
      onCellClicked: (event: any) => {
        callBackAction(CallBackActionColumn.VIEW_NOMALIZED_CV, {
          data: event?.data,
        });
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.FULL_NAME"),
      cellStyle: getDefaultStyle(),
      field: "extraInfo",
      width: 200,
      minWidth: 200,
      cellRenderer: (data) => {
        const parsedValue = !!data?.value?.value ? JSON.parse(data?.value?.value) : ''
        const result = parsedValue?.fullName || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      }
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.REQUIREMENT"),
      cellStyle: getDefaultStyle(),
      field: "requirement",
      flex: 1,
      width: 250,
      minWidth: 250,
      cellRenderer: (data) => {
        const parsedValue = !!data?.value?.value ? JSON.parse(data?.value?.value) : ''
        const result = UtilCommon.getLabelLanguage(parsedValue) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      }
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.SENDING_SCHEDULE"),
      cellStyle: getDefaultStyle(),
      field: "sendingSchedule",
      minWidth: 200,
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.formatDate(data.value);
        return result;
      }
    },
    {
      headerName: translocoService.translate("WORKFLOW.TASK.LABEL.DEADLINE"),
      cellStyle: getDefaultStyle(),
      field: "deadline",
      minWidth: 200,
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        const result = UtilCommon.formatDate(data.value);
        return result;
      }
    }
  ];
};

export const getColumnMatchCandidate = (
  utilComponent: UtilComponent,
  translocoService: TranslocoService
) => {
  return [
    {
      headerName: 'Select',
      field: 'id',
      cellRenderer: 'matCheckboxRenderer', // Sử dụng cellRenderer cho từng dòng
      headerComponent: 'matHeaderCheckbox',  // Sử dụng `mat-checkbox` cho header
      width: 70,
      minWidth: 70,
      // resizable: false
    },
    utilComponent.commonColumnNo("No", "no", 100),
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.SOURCE",
        "source",
        180,
        false,
        true
      ),
      hide: true,
      maxWidth: 250,
      // rowGroup: enbaleDefaultRowGroup
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      }
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.SOURCE_TYPE",
        "sourceType",
        180,
        false,
        true
      ),
      hide: true,
      maxWidth: 250,
      // rowGroup: enbaleDefaultRowGroup
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.FULL_NAME"),
      cellStyle: getDefaultStyle(),
      field: "fullName",
      width: 250,
      minWidth: 250,
      maxWidth: 350,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      }
    },
    {
      headerName: translocoService.translate("CANDIDATE.LABEL.GENDER"),
      hide: true,
      enableRowGroup: true,
      cellStyle: getDefaultStyle(),
      field: "gender",
      width: 150,
      minWidth: 100,
      maxWidth: 250,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      },
      suppressSizeToFit: true
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.DOB",
        "dob",
        200,
        false,
        false
      ),
      hide: false,
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.formatDate(data.value);
      },
      width: 200,
      minWidth: 200,
      maxWidth: 200
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.EMAIL",
        "personalEmail",
        180,
        true,
        false
      ),
      maxWidth: 250
    },
    {
      headerName: translocoService.translate("CANDIDATE_GROUP.LABEL.REFERENCE_EMAIL"),
      cellStyle: getDefaultStyle(),
      field: "referenceEmail",
      width: 200,
      cellRenderer: (data) => {
        let result = UtilCommon.getLabelLanguage(data?.value?.label || data?.value?.name || data?.value) || "";
        return `<div class="custom-cell-truncate" title="${result}">${result}</div>`;
      }
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.MOBILE",
        "mobile",
        180,
        true,
        false
      ),
      maxWidth: 250
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.STATE",
        "state",
        150,
        false,
        false
      ),
      maxWidth: 200,
      cellRenderer: (item) => {
        return UtilCommon.capitalizeFirstCharacterOfWords(item.value);
      },
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "CANDIDATE.LABEL.APPLY_DATE",
        "applyDate",
        200,
        false,
        false
      ),
      // hide: true,
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.formatDateFullTime(data.value);
      },
      width: 200,
      minWidth: 200,
      maxWidth: 200
    },
    // {
    //   ...utilComponent.commonColumnAgGrid(
    //     "CANDIDATE.LABEL.MATCH_ID",
    //     "makerId",
    //     150,
    //     false,
    //     false
    //   ),
    //   minWidth: 150,
    //   maxWidth: 300,
    // },
    // {
    //   ...utilComponent.commonColumnAgGrid(
    //     "CANDIDATE.LABEL.MATCHING_DATE",
    //     "matchingDate",
    //     200,
    //     false,
    //     false
    //   ),
    //   filter: 'agDateColumnFilter',
    //   filterParams: {
    //     applyButton: true,
    //     newRowsAction: 'keep'
    //   },
    //   cellStyle: getDefaultStyle(),
    //   cellRenderer: (data) => {
    //     if (!data || !data?.value) {
    //       return "";
    //     }
    //     return UtilCommon.formatDateFullTime(data.value);
    //   },
    //   minWidth: 200,
    //   maxWidth: 200,
    // },
    {
      ...utilComponent.commonColumnAgGrid(
        "GENERAL.UPDATE_ID",
        "updateId",
        150,
        false,
        false
      ),
      minWidth: 150,
      maxWidth: 250,
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.getNameFromEmail(data.value);
      },
    },
    {
      ...utilComponent.commonColumnAgGrid(
        "GENERAL.UPDATE_DATE",
        "updateDate",
        200,
        false,
        false
      ),
      filter: 'agDateColumnFilter',
      filterParams: {
        applyButton: true,
        newRowsAction: 'keep'
      },
      cellStyle: getDefaultStyle(),
      cellRenderer: (data) => {
        if (!data || !data?.value) {
          return "";
        }
        return UtilCommon.formatDateFullTime(data.value);
      },
      minWidth: 200,
      maxWidth: 200,
    }
  ];
};

function getDefaultStyle() {
  return {
    "text-overflow": "ellipsis",
    "white-space": "nowrap",
    overflow: "hidden",
    display: "block",
  };
}

export const FILTER_CONTROLS_MATCH: XAdvancedFilterControl[] = [
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'fullName.en',
    label: 'CANDIDATE.LIST.NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'lastName.en',
    label: 'CANDIDATE.LIST.LAST_NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'firstName.en',
    label: 'CANDIDATE.LIST.FIRST_NAME'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'personalEmail',
    label: 'CANDIDATE.LIST.EMAIL'
  },
  {
    value: '',
    type: ControlType.DateTime,
    required: true,
    fieldName: 'dob',
    label: 'CANDIDATE.LABEL.DATE_OF_BIRTH'
  },
  {
    value: '',
    type: ControlType.Select,
    required: true,
    fieldName: 'genderId',
    isMultiple: true,
    label: 'CANDIDATE.LIST.GENDER'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'mobile',
    label: 'CANDIDATE.LIST.MOBILE'
  },
  {
    value: '',
    type: ControlType.Select,
    required: true,
    fieldName: 'state',
    isMultiple: true,
    label: 'CANDIDATE.LABEL.STATE'
  },
  // {
  //   value: '',
  //   type: ControlType.Input,
  //   required: true,
  //   fieldName: 'requestCode',
  //   label: 'CANDIDATE.LIST.REQUEST_CODE'
  // },
  {
    value: '',
    type: ControlType.DateTime,
    required: true,
    fieldName: 'updateId',
    label: 'GENERAL.UPDATE_ID'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'cvFtsValue',
    label: 'CANDIDATE.LIST.CV_CONTENT'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsJobTitle',
    label: 'CANDIDATE.LIST.ADS_JOB_TITLE'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsLocation',
    label: 'CANDIDATE.LIST.ADS_LOCATION'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsSkill',
    label: 'CANDIDATE.LIST.ADS_SKILL'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsCompany',
    label: 'CANDIDATE.LIST.ADS_COMPANY'
  },
  {
    value: '',
    type: ControlType.Input,
    required: true,
    fieldName: 'adsSchool',
    label: 'CANDIDATE.LIST.ADS_SCHOOL'
  },
  {
    value: '',
    type: ControlType.Numeric,
    required: true,
    fieldName: 'adsYearOfExperience',
    label: 'CANDIDATE.LIST.ADS_YEAR_OF_EXP'
  },
  {
    value: '',
    type: ControlType.Numeric,
    required: true,
    fieldName: 'adsYearInCurrentCompany',
    label: 'CANDIDATE.LIST.ADS_YEAR_CURR_COMPANY'
  }
]

export const GROUP_CONTROLS_MATCH: XAdvancedGroupControl[] = [
  {
    fieldName: 'state',
    active: false,
    label: 'CANDIDATE.LABEL.STATE',
  }
]

export const GROUP_CONTROLS_CANDIDATE_MATCHED: XAdvancedGroupControl[] = [
  {
    fieldName: 'displayStatus',
    active: false,
    label: 'CANDIDATE.LABEL.REQ_STATUS',
  }
]

export function getAllCandidateIds(worker: any, excludeEmail: string = null): number[] {
  if (!worker || !Array.isArray(worker.candidate) || worker.candidate.length === 0) return [];

  return worker.candidate.flatMap(candidate => {
    const candidateIds = [];

    // Add the candidate's own ID
    if (candidate.id != null) {
      candidateIds.push(candidate.id);
    }

    // Add nested candidate IDs from details
    if (Array.isArray(candidate.details) && candidate.details.length > 0) {
      const nestedIds = candidate.details.flatMap(detail =>
        detail.group &&
          Array.isArray(detail.group.details) &&
          detail.group.details.length > 0
          ? detail.group.details
            .filter(d =>
              d.candidate &&
              d.candidate.id != null &&
              (!excludeEmail || d.candidate.email !== excludeEmail)
            )
            .map(d => d.candidate.id)
          : []
      );
      candidateIds.push(...nestedIds);
    }

    return candidateIds;
  });
}